
function spliceDecimal(no, upto) {
  if (no) {
    let str = no.toString();
    let first = str.split('.')[0];
    let second = str.split('.')[1];
    let second2 = second ? second.substring(0, upto) : ""
    let final = first + '.' + second2;
    if (second2) {
      return parseFloat(final).toFixed(upto)
    } else {
      return no
    }
  } else {
    return 0
  }
}


// function addLogic(q_list, a_list, getSurveyTemplateByCodeData) {
// let logic_list = [];
// if (getSurveyTemplateByCodeData && getSurveyTemplateByCodeData.logicDetails && getSurveyTemplateByCodeData.logicDetails.length > 0) {
//   logic_list = getSurveyTemplateByCodeData.logicDetails;
// }
//   let skipQuestions = []
//   if (a_list && a_list.length > 0) {
//     let new_a_list = a_list.filter(prev => prev.template === 1).filter(ans => ans.isLogic === true);
//     if (new_a_list && new_a_list.length > 0) {
//       new_a_list.forEach((ans) => {
//         let new_logic_list = logic_list.filter(prev => prev.questionId.toString() === ans.questionId.toString())
//         if (new_logic_list && new_logic_list.length > 0) {
//           let getIndex = new_logic_list.findIndex(prev => prev.optionName.toString() === ans.answer.toString());
//           if (getIndex !== -1) {
//             let logic_ques_skip = [];
//             if (new_logic_list && new_logic_list[getIndex] && new_logic_list[getIndex]["logicQues"] && new_logic_list[getIndex]["logicQues"].length > 0) {
//               logic_ques_skip = new_logic_list[getIndex]["logicQues"].filter(prev => prev.skip === true).map((ele) => (ele.logicQId.toString()))
//             }

//             if (logic_ques_skip && logic_ques_skip.length > 0) {
//               logic_ques_skip.forEach((ele) => {
//                 skipQuestions.push(ele)
//               })
//             }

//           }
//         }
//       })
//     }
//   }
//   //console.log("skipQuestions--->",skipQuestions)
//   let final_list = []
//   if (q_list && q_list.length > 0) {
//     q_list.forEach((ele) => {
//       if (!skipQuestions.includes(ele.id)) {
//         final_list.push(ele)
//       }
//     })
//   }
//   return final_list
// }
function addLogic(q_list, a_list, getSurveyTemplateByCodeData) {
  let logic_list = [];
  if (getSurveyTemplateByCodeData && getSurveyTemplateByCodeData.logicDetails && getSurveyTemplateByCodeData.logicDetails.length > 0) {
    logic_list = getSurveyTemplateByCodeData.logicDetails;
  }


  if (!a_list?.length || !logic_list?.length) return q_list || [];

  const skipQuestions = new Set();

  a_list
    .filter(ans => ans.template === 1)
    .filter(ans => ans.isLogic === true)
    .forEach(ans => {
      logic_list
        .filter(logic => logic.questionId.toString() === ans.questionId.toString())
        .forEach(logic => {
          if (logic.optionName.toString() === ans.answer.toString()) {
            logic.logicQues?.forEach(q => {
              if (q.skip) skipQuestions.add(q.logicQId.toString());
            });
          }
        });
    });

  return q_list?.filter(q => q.isMandatory ? true : !skipQuestions.has(q.id.toString())) || [];
}



function getQuestionPair(quesList) {
  const pairObj = (quesList || []).reduce((acc, item) => {
    if (item?.pair != null) {
      const key = item.pair.toString();
      (acc[key] ||= []).push(item);
    }
    return acc;
  }, {});

  const pairList = Object.entries(pairObj).map(([pair, quesList]) => ({
    pair,
    quesList
  }));
  return pairList
}

function reverseFn(originalArray) {
  let reversedArray = [];
  if (originalArray && originalArray.length > 0) {
    for (let i = originalArray.length - 1; i >= 0; i--) {
      reversedArray.push(originalArray[i]);
    }
  }
  return reversedArray
}

export { spliceDecimal, addLogic, getQuestionPair, reverseFn }
